import { useEffect, useState } from 'react';

import {
  TableCreator,
  TableCreatorMeta,
  TableMaskType,
} from '@core/design-system/table-creator';
import { marketData } from '@core/market-data-sdk';
import { useRouter } from 'next/router';

const columns = new TableCreator()
  .addColumn({
    key: 'start_applying_at',
    header: 'Data',
    size: 50,
    meta: new TableCreatorMeta().mask(TableMaskType.DATE),
  })
  .addColumn({
    key: 'comment',
    header: 'Alteração',
    size: 200,
  })
  .getColumns();

export const useManagerData = () => {
  const router = useRouter();
  const [managerData, setManagerData] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const { slug } = router.query;

  useEffect(() => {
    setLoading(true);
    const dadosAlterados = async () => {
      const { adjustments } =
        await marketData.funds.manager.getFundsAdjustments(slug as string);

      if (adjustments?.length) {
        setManagerData(adjustments || []);
      }
    };

    if (slug) {
      dadosAlterados();
    }
    setLoading(false);
  }, [slug]);

  return {
    columns,
    managerData,
    loading,
  };
};
